import {
  Description as DescriptionIcon,
  Folder as FolderIcon,
  Image as ImageIcon,
  ListAlt as ListAltIcon,
} from "@mui/icons-material";
import React from "react";

type Props = {
  droppable: boolean;
  fileType?: string;
};

export const TypeIcon: React.FC<Props> = (props) => {
  if (props.droppable) {
    return <FolderIcon />;
  }

  switch (props.fileType) {
    case "image":
      return <ImageIcon />;
    case "csv":
      return <ListAltIcon />;
    case "text":
      return <DescriptionIcon />;
    default:
      return null;
  }
};
